import { render, staticRenderFns } from "./AddAcademic.vue?vue&type=template&id=114b802e&scoped=true"
import script from "./AddAcademic.vue?vue&type=script&lang=js"
export * from "./AddAcademic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b802e",
  null
  
)

export default component.exports